import { createStyles, getSize, rem } from '@mantine/styles';
var GROUP_POSITIONS = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var useStyles = createStyles(function (theme, _ref) {
  var spacing = _ref.spacing,
      position = _ref.position,
      noWrap = _ref.noWrap,
      grow = _ref.grow,
      align = _ref.align,
      count = _ref.count;
  return {
    root: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: align || "center",
      flexWrap: noWrap ? "nowrap" : "wrap",
      justifyContent: GROUP_POSITIONS[position],
      gap: getSize({
        size: spacing,
        sizes: theme.spacing
      }),
      "& > *": {
        boxSizing: "border-box",
        maxWidth: grow ? "calc(".concat(100 / count, "% - (").concat(rem(getSize({
          size: spacing,
          sizes: theme.spacing
        })), " - ").concat(getSize({
          size: spacing,
          sizes: theme.spacing
        }), " / ").concat(count, "))") : void 0,
        flexGrow: grow ? 1 : 0
      }
    }
  };
});
export default useStyles;
export { GROUP_POSITIONS };